export enum Language {
  ENGLISH = 'ENGLISH',
  ARMENIAN = 'ARMENIAN',
  RUSSIAN = 'RUSSIAN'
}
